<template>
    <div>
        <loading :active.sync="bool_fullLoading"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class="pageHeader position-relative">
                        <h2 id="titleHeight">{{ getLanguage["HEA"]["N"] }}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="/src/assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <!--Search-->
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{ getLanguage["NOTI"]["AC"] }} :</span>
                                <CInput size="sm"
                                        :value="searchC" :placeholder="getLanguage['AN']['SH']"
                                        @change="v => searchC = v" />
                            </div>

                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{ getLanguage["BTN"]["SR"] }}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['HEA']['N']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="ReadAll()">
                            {{this.getLanguage["HEA"]["NRA"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="row" v-if="arry_cl.length == 0">
                    <div class="col-12 my-1">
                        <h5 class="font-weight-bold mb-0">{{ getLanguage['GL']['NR'] }}</h5>
                    </div>
                </div>

                <div class="row" v-for="item in arry_cl.dateList" v-else>
                    <div class="col-12 my-1">
                        <h6 class="font-weight-bold mb-0">{{ item }}</h6>
                    </div>

                    <div class="col-12 my-1" v-for="(data,index) in arry_cl" v-if="FormatNotifDate(data.CTS, item)">
                        <CCard class="border-0" @click="Read(index, data.IR, data.I)">
                            <CCardBody :class="data.IR ? 'card-read': 'card-unread'">
                                <div class="w-100 d-inline-block text-break">
                                    <small class="notif-time text-muted">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "HH:mm:ss") }}</small>
                                    <div class="float-left">
                                        <h6 class="notif-content-title font-weight-bold mb-0">{{ data.T }}</h6>
                                        <span v-html="data.CBD"></span>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from 'vue-loading-overlay';
    import moment from "moment";

    export default {
        mixins: [genericHelper],
        components: {
            Loading
        },
        data() {
            return {
                collapse: -1,
                arry_cl: {
                    T: null,
                    CTS: "0001-01-01T00:00:00",
                    CDT: "0001-01-01T00:00:00",
                    CBD: null,
                    IR: 0,
                    I: 0,
                    dateList: [],
                },
                arry_setIsRead_List: [],
                bool_fullLoading: false,
                bool_showSearchBar: true,
                //the parameter of getList()
                int_Page: 1,//current Page
                int_IC: 1, //Item Count
                int_RC: 200, //Row Count
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Descending
                str_FV: "", //Filter Value

                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page

                //date
                ND_List: [],

                searchC: null, //Filter Value
            }
        },
        methods: {
            ReadAll() {
                this.arry_cl.forEach((value, key) => {
                    if (!value.IR) {
                        var that = this;
                        this.getDataApi(`/api/anotif/ga/${value.I}`,
                            function (d, s) {
                                if (s) {
                                    that.getNotifList();
                                }
                            });
                    }
                });
            },
            Read(index, bool_IR, Id) {
                if (this.collapse != index) {
                    this.collapse = index;
                } else {
                    this.collapse = -1;
                }

                if (!bool_IR) {
                    var that = this;
                    this.getDataApi(`/api/anotif/ga/${Id}`,
                        function (d, s) {
                            if (s) {
                                that.getNotifList();
                            }
                        });
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                } else {
                    return value;
                }
            },
            //FormatNotifTime(date){
            //    return moment(date).fromNow();
            //},
            FormatNotifTime(loginDateTime, currentTime) {
                let d = (new Date(currentTime)) - (new Date(loginDateTime));
                let W = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
                let DDAY = Math.floor(d / 1000 / 60 / 60 / 24 - W * 7);
                let DHR = Math.floor(d / 1000 / 60 / 60 - W * 7 * 24 - DDAY * 24);
                let DMT = Math.floor(d / 1000 / 60 - W * 7 * 24 * 60 - DDAY * 24 * 60 - DHR * 60);
                let DSC = Math.floor(d / 1000 - W * 7 * 24 * 60 * 60 - DDAY * 24 * 60 * 60 - DHR * 60 * 60 - DMT * 60);
                let t = {};
                ['DDAY', 'DHR', 'DMT', 'DSC'].forEach(q => { if (eval(q) > 0) { t[q] = eval(q); } });

                var dateKey = Object.keys(t);
                var temp = ""
                for (var i = 0; i < dateKey.length; i++) {
                    temp += t[dateKey[i]] + " ";
                    temp += this.getLanguage['MEM'][dateKey[i]] + " ";
                }
                return temp;
            },
            FormatNotifDate(date, selectedDate) {
                if (moment(date).format('DD MMM YYYY') == selectedDate) {
                    return true;
                } else {
                    return false;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getNotifList();
            },
            getNotifList() {
                this.bool_fullLoading = true;
                this.arry_setIsRead_List = [];
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.searchC != null && this.searchC != "") {
                    path += "&f.C=" + this.searchC;
                }

                this.getDataApi(`/api/anotif/l/u?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setNotifList(d.D);
                        }
                    });
            },
            setNotifList(returnD) {   // this out put at Notif.js and this output after get list
                this.arry_cl = returnD.Items;
                this.int_TP = Math.max(returnD.TotalPages, 1);                
                this.int_TI = returnD.TotalItems;

                this.arry_cl.dateList = [];
                this.arry_cl.forEach((value, key) => {
                    if (!this.arry_cl.dateList.includes(moment(value.CTS).format('DD MMM YYYY'))) {
                        this.arry_cl.dateList.push(moment(value.CTS).format('DD MMM YYYY'));
                    }
                    //if (!this.ND_List.includes(moment(value.CTS).format('DD MMM YYYY'))) {
                    //    this.ND_List.push(moment(value.CTS).format('DD MMM YYYY'));
                    //}
                });

            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getNotifList();

            },
        },
        created() {
            this.getNotifList();
            this.searchC = this.$route.query.c;

        },
    }
</script>
<style>
    .card a {
        color: #636f83;
    }

    .contentWrapper {
        background: #fff;
        width: 100%;
        margin-top: 1rem;
    }

    .card-read {
        padding: 10px 20px;
        background: #fff !important;
        border-radius: 20px;
        border: solid 1px #ced2d8;
    }

    .card-unread {
        padding: 10px 20px;
        background: #f6f5fd !important;
        border-radius: 20px;
        border: solid 1px #ced2d8;
        cursor: pointer;
    }

    .notif-time {
        position: absolute;
        right: 0;
        padding-right: 20px;
    }

    .notif-content-title {
        width: 95%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Page/Notifications.vue